<template>
  <div >
    <OrderListCommon :status="status" @listt="listt" :urlT="urlT"></OrderListCommon>
  </div>
</template>

<script>
import OrderListCommon from "../common/OrderListCommon";
export default {
  created() {
    this.$emit("Active", 2);
  },
  data() {
    return {
      status: 30,
      sendList: [],
       urlT:'/Particular/particularReconciliation'
    };
  },
  methods: {
    listt(listt) {
      this.sendList = listt;
      this.$emit("list", this.sendList);
    }
  },
  components: {
    OrderListCommon
  }
};
</script>

<style scoped>

</style>